module.exports = __webpack_public_path__ + "static/media/arrow-calendar.825456d1.svg";